import { gql } from '@apollo/client';

export const CHECKLIST_UPDATED = gql`
  subscription checklistUpdated {
    checklistUpdated {
      requiredDocumentId
    }
  }
`;

export const CHECKLIST_TYPE_PROPERTIES_UPDATED = gql`
  subscription checklistTypePropertiesUpdated {
    checklistTypePropertiesUpdated {
      requiredDocTypeId
    }
  }
`;

export const CHECKLIST_FILTER_UPDATED = gql`
  subscription checklistTypeFiltersUpdated {
    checklistTypeFiltersUpdated {
      requiredDocTypeId
    }
  }
`;

export const CHECKLIST_X_USER_GROUPS_UPDATED = gql`
  subscription checklistXUserGroupsUpdated {
    checklistXUserGroupsUpdated {
      requiredDocTypeId
    }
  }
`;

export const CHECKLIST_VERIFIED = gql`
  subscription checklistVerified {
    checklistVerified {
      invalidateDocumentTemplates
    }
  }
`;
